import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import Row from 'antd/lib/grid/row';
import BeginnerCard from './BeginnerCard';
import Advanced1Card from './Advanced1Card';
import Advanced2Card from './Advanced2Card';

@inject('onboardingStore')
@observer
class LevelPicker extends React.Component {
  render() {
    if (this.props.onboardingStore.flow === 'test') {
      this.props.onboardingStore.disableNextWizard();
    } else {
      this.props.onboardingStore.enableNextWizard();
    }
    return (
      <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: '13px' }}>
        <BeginnerCard />
        <Advanced1Card />
        <Advanced2Card />
      </Row>
    );
  }
}

LevelPicker.propTypes = {
  onboardingStore: PropTypes.object
};

export default LevelPicker;
